import { Box, Button, Stack } from "@mui/material";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import type { RegisterInput } from "../../../../api/register";
import { checkDocument } from "../../../../api/register";
import DocumentTextField from "../../../../components/DocumentTextField";
import { notify } from "../../components/Toast";

export interface CpfCnpjStepProps {
  handleNext: () => void;
  handleCancel: () => void;
}

function CpfCnpjStep({
  handleNext,
  handleCancel,
}: CpfCnpjStepProps): React.JSX.Element {
  const { t } = useTranslation();
  const { control, setError, resetField } = useFormContext<RegisterInput>();
  const [block, onBlock] = useState(false);

  return (
    <Stack alignItems="center" spacing={3}>
      <Controller
        control={control}
        name="cpf"
        render={({ field, fieldState }) => {
          const { error } = fieldState;
          const { value, name, onBlur, ref, onChange, disabled } = field;
          return (
            <DocumentTextField
              disabled={disabled}
              error={Boolean(error)}
              fullWidth
              helperText={error?.message || " "}
              name={name}
              onBlur={() =>
                void (async () => {
                  if (error === undefined) {
                    const dataCheckedCpf = await checkDocument(field.value);
                    if (dataCheckedCpf.exists) {
                      onBlock(false);
                      setError("cpf", {
                        message: t("register.cpfAlreadyRegistered"),
                      });
                    }

                    if (!dataCheckedCpf.exists) {
                      onBlock(true);
                    }

                    if (!dataCheckedCpf) {
                      const message = t("register.serviceUnavailable");
                      setError("cpf", {
                        message,
                      });
                      notify(message, "info", "");
                    }
                  } else {
                    resetField("cpf", {
                      keepError: false,
                    });
                  }
                  onBlur();
                })()
              }
              onChange={onChange}
              ref={ref}
              value={value}
              variant="outlined"
            />
          );
        }}
      />
      <Box
        alignItems="center"
        display="flex"
        justifyContent="flex-end"
        marginTop="5%"
        width="100%"
      >
        <Button
          color="primary"
          disabled={!block}
          onClick={handleNext}
          size="large"
          tabIndex={0}
          type="button"
          variant="contained"
        >
          {t("common.next")}
        </Button>
      </Box>
      <Box marginTop="10%" textAlign="end" width="100%">
        <Button
          color="success"
          component={Link}
          onClick={handleCancel}
          size="medium"
          to=""
          variant="text"
        >
          {t("common.cancelRegistration")}
        </Button>
      </Box>
    </Stack>
  );
}

export default CpfCnpjStep;
